import React, { useEffect, useState } from 'react';
import ShapeWhite from '../Assets/images/logo.png';
import '../Assets/css/vendor.min.css';
import '../Assets/css/style.css';
import '../Assets/css/media.css';
import { Link, useLocation } from 'react-router-dom';
import { BASE_IMAGE_URL, BASE_URL } from "../config";
import axios from 'axios';


const Header = () => {
    const [imageUrl, setImageUrl] = useState("");
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        axios.get(`${BASE_URL}/site-settings`)
            .then(res => {
                if (res.data.status === 200 && res.data.data) {
                    const data = res.data.data;
                    setImageUrl(`${BASE_IMAGE_URL}/${data.logo}`)
                }
            })
            .catch(err => {
                console.error("Failed to fetch contact info:", err);
            });
    }, []);
    useEffect(() => {
    if (isMenuOpen) {
        document.body.classList.add('layout-expanded2');
    } else {
        document.body.classList.remove('layout-expanded2');
    }
}, [isMenuOpen]);

    // console.log(imageUrl)

    const [isSticky, setSticky] = useState(false);
    const location = useLocation();
    const handleNavToggle = (e) => {
    e.preventDefault();
    setIsMenuOpen(prev => !prev);
};

  


    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 0); // or a number like 50
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <>

            <header className={`headercontainer ${isSticky ? 'sticky' : ''}`}>
                <div className="btmheader">
                    <div className="container">
                        <div className="headtopouter">
                            <div className="headtoprow">
                                <div className="logocontainer">
                                    <Link to="/"><img src={imageUrl} alt="Logo" /></Link>
                                </div>
                                <div className="navigation">
                                    <div className="navigationbox">
                                        <div className="navuser">
                                            <Link to="/" className="userimg">
                                                <img src={imageUrl} alt="Logo" />
                                            </Link>
                                            <h3><Link to="/">RCA Capacitors</Link></h3>
                                        </div>
                                        <ul className="sf-menu">
                                            <li className={location.pathname === '/' ? 'active' : ''}><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
                                            <li className={location.pathname === '/product-view' ? 'active' : ''}><Link to="/product-view" onClick={() => setIsMenuOpen(false)}>Products</Link></li>
                                            <li className={location.pathname === '/about-us' ? 'active' : ''}><Link to="/about-us" onClick={() => setIsMenuOpen(false)}>About Us</Link></li>
                                            {/* <li className={location.pathname === '/blog' ? 'active' : ''}><Link to="/blog">Blog</Link></li> */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="usersbxouter">
                                    <div className="usersbx">
                                        <ul>
                                            <li><Link className="searchbtn d-none" href="javascript:void(0);" ><i className="icon icon-search"></i></Link></li>
                                            <li className="usericon d-none"><a href="javascript:void(0);"><i className="icon icon-user-o"></i></a></li>
                                            <li className="d-none"><Link href="javascript:void(0);"><i className="icon icon-cart-bag"></i><span className="badgetx">0</span></Link></li>
                                        </ul>
                                    </div>
                                    <Link className="theme-btn" to="/contact-us/0/0">Contact Us</Link>
                                    <div className="menu-overlay" onClick={() => setIsMenuOpen(false)}></div>
                                        <Link to="#" className="NavBar" onClick={handleNavToggle}><i className="fa fa-bars"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

        </>

    )
}

export default Header